export default [
  "Use of Proceeds",
  "Process for Project Evaluation and Selection",
  "Management of Proceeds",
  "Reporting",
  "External Review",
  "Framework Updates",
];
